const ANIMATION_STATE = {
    WALK: "Walk",
    RUN: "Run",
    IDLE: "Idle",
};
export { ANIMATION_STATE };
